export default "__VITE_ASSET__DQnUx7gC__"